export default __webpack_public_path__ + "static/media/104t.7d63b5f9.jpg";